import usePayment from "_data/hooks/payment/usePayment";
import BillingForm from "_features/BillingForm";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  billingDetailsErrorMessage,
  reportPaymentError,
} from "_data/services/payment/paymentErrors";

export function BillingView() {
  const { initiatePayment, getInitialBillingAddress, sendBillingAddress } =
    usePayment();

  const location = useLocation();
  const navigate = useNavigate();
  let subscriptionType = location.state?.subscriptionType;

  const subscribe = () => {
    // Opened without a plan (a bookmark, a refresh): there is nothing to pay for, the user is
    // just editing their billing details.
    if (!subscriptionType) {
      navigate("/account");
      return;
    }

    initiatePayment(subscriptionType, (success, errorCode) => {
      if (success) {
        return;
      }

      // Already on the billing form, so there is nowhere to send the customer -- these codes are
      // silent everywhere else precisely because everywhere else redirects here. Saying what is
      // missing beats the button appearing to do nothing at all.
      const billingMessage = billingDetailsErrorMessage(errorCode);
      if (billingMessage) {
        toast.error(billingMessage);
        return;
      }

      reportPaymentError(errorCode);
    });
  };

  return (
    <div className="flex flex-col w-full h-full justify-center items-center my-[20px]">
      <div className="flex flex-col w-2/5 h-fit items-center border-[1px] border-primaryBlue p-5">
        <BillingForm
          subscribe={subscribe}
          getInitialBillingAddress={getInitialBillingAddress}
          sendBillingAddress={sendBillingAddress}
          showAcceptingTerms={location.pathname.includes("billing")}
        />
      </div>
    </div>
  );
}
